/**
 * TendrilStatusAnnouncer — visually-hidden `aria-live="polite"` announcer
 * for discrete Tendril turn transitions (tendril-streaming-responses Phase 3,
 * WI-008, JD-10 accessibility requirement).
 *
 * Announces ONLY on discrete transitions the caller decides are worth a
 * screen-reader announcement (turn start / first token / done-ok /
 * degraded-soft / degraded-hard / error-or-stall) — never per status line,
 * never per token. The caller (TendrilChatPanel) owns transition detection;
 * this component is a pure presentational sink for the current announcement
 * string.
 *
 * `aria-atomic="true"` so the whole announcement text is read, not a diff.
 */
import React from 'react';

/**
 * @param {{ announcement: string }} props
 */
export default function TendrilStatusAnnouncer({ announcement }) {
  return (
    <div
      className="tendril-status-announcer"
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
      }}
    >
      {announcement}
    </div>
  );
}
